export default {"src":"/_next/static/media/ACHR.cb477c98.svg","height":18,"width":18};